<template>
  <div class="normal-list">
    <div class="item-header">
      <p class="item-header-id">订单号：{{ item.orderIdStr || item.id || item.orderId}}</p>
      <p class="item-header-time">{{ item.time | formatTime }}</p>
    </div>
    <div class="item-content">
      <div
        class="item-pic"
        :style="{ backgroundImage: 'url(' + $setPicSize(item.img) + ')' }"
      ></div>
      <div class="item-info">
        <div class="title">
          <span v-if="item.orderType == 2" class="tag"></span>
          <span>{{ item.title }}</span>
        </div>
        <div v-if="item.orderType != 2" class="price">
          <div v-if="item.price / 100 > 0">
            ￥<span>{{ item.price / 100 }}</span>
          </div>
        </div>
        <div v-if="item.orderType == 2" class="price">
          ⭐<span>{{ item.payStar }}</span>
        </div>
        <div class="status">{{ item.status }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import setPicSize from '@zz-app/setPicSize'
import phoneImg from '../../../../../assets/img/phone.png'
import bookImg from '../../../../../assets/img/books.png'

export default {
  name: 'NormalList',
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  filters: {
    formatTime(time) {
      return time ? new Date(Number(time)).format('YYYY-MM-DD') : ''
    }
  },
  methods: {
    $setPicSize(url) {
      if (this.item.orderType == 3) return phoneImg
      if (this.item.orderType == 4) return bookImg
      return setPicSize(url, 100, 100)
    }
  }
}
</script>
<style lang="less" scoped>
  @import 'index.less';
</style>
